import { RouteInfo } from '@/types/schema'

/**
 * Gets the full image URL from path
 */
export function getImageUrl(src: string, size: string = ''): string {
  if (!src) return ''

  // Handle already full URLs
  if (src.startsWith('http')) {
    return src
  }

  // Base image URL
  const baseUrl = 'https://www.coolmate.me/images/'

  // Add size suffix if needed
  if (size) {
    const parts = src.split('.')
    const extension = parts.pop()
    return `${baseUrl}${parts.join('.')}_${size}.${extension}`
  }

  return `${baseUrl}${src}`
}

/**
 * Maps pathname to route name (similar to Laravel route names)
 */
export function getRouteInfo(pathname: string): RouteInfo {
  // Remove leading slash and split into segments
  const path = pathname.replace(/^\//, '')
  const segments = path.split('/')
  const firstSegment = segments[0] || ''

  // Direct route mappings
  const routeMap: Record<string, string> = {
    '': 'home',
    'about-us': 'about-us',
    blog: 'blog',
    'size-chart': 'size-chart',
    builder: 'builder',
    'medium-box': 'medium-box',
    'large-box': 'large-box',
    filter: 'filter.index',
    '84rising': '84rising',
    cm24: 'cm24',
  }

  let routeName = routeMap[firstSegment] || ''
  // Pattern-based routes
  if (!routeName) {
    const patternRoutes = {
      collection: 'collection',
      product: 'product',
      blog: 'blog.detail',
      post: 'single-article',
      page: 'page-detail',
      campaign: 'campaign-detail',
    }

    // Check if firstSegment matches any pattern route and has sub-segments
    if (segments.length > 1 && firstSegment in patternRoutes) {
      routeName = patternRoutes[firstSegment as keyof typeof patternRoutes]
    } else {
      // Default to home if no match
      routeName = 'home'
    }
  }

  return {
    pathname,
    routeName,
  }
}

/**
 * Is this a landing page URL?
 */
export function isLandingPage(pathname: string): boolean {
  return pathname === '/lp/coolmate-101'
}
